const data_collecting = [
  {
    name: 'mangrove',
    icon: 'file-list-3-line',
  },
]
const data_activity = [
  {
    name: 'mangrove_planting_socialization',
    icon: 'plant',
  },
]

const module = {
  config: {
    name: "mangrove-data",
    icon: 'drop',
    desc: "Data utama untuk pengelolaan Pendataan Mangrove",
    layout: true,
    order: 2
  },
  routes: [
    {
      name: 'pendataan-mangrove',
      type: 'parent',
      // icon: "user",
      redirectName: 'mangrove',
      child: [
        ...data_collecting.flatMap(v => {
          return {
            name: v.name,
            icon: v.icon,
            path: `/${v.name}`,
            translate_key: v.name,
            component: () => import(`./mangrove-data-collecting/${v.name}.vue`),
            separator: null
          }
        }),
      ]
    },
    {
      name: 'mangrove-activity',
      type: 'parent',
      // icon: "user",
      redirectName: 'mangrove',
      child: [
        ...data_activity.flatMap(v => {
          return {
            name: v.name,
            icon: v.icon,
            path: `/${v.name}`,
            translate_key: v.name,
            component: "",
            separator: null
          }
        }),
      ]
    },
  ]
};
export default module;



// WEBPACK FOOTER //
// ./src/modules/mangrove/_index.js